import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  api: string = environment.apiEndPoint;

  constructor(private http: HttpClient) { }

  private buildQueryParams(data: any): any {
    if (!data) {
      return {};
    }

    return Object.keys(data).reduce((params: any, key: string) => {
      const value = data[key];
      if (value !== null && value !== undefined && value !== '') {
        params[key] = value;
      }
      return params;
    }, {});
  }

  getReportSearchSD() {
    return this.http.get(this.api + '/SMSRpt/GetSearchSD');
  }

  getSmsReport(data: any) {
    return this.http.get(this.api + '/SMSRpt', { params: this.buildQueryParams(data) });
  }

  getSmsReportCsv(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMSSummaryRptCSV', { params: this.buildQueryParams(data), responseType: 'blob' });
  }

  getSmsSummaryReport(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMSSummaryRpt', { params: this.buildQueryParams(data) });
  }

  getInstantSmsReport(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetInstantSMSRpt', { params: this.buildQueryParams(data) });
  }

  getInstantSmsSummaryReport(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetInstantSMSSummaryRpt', { params: this.buildQueryParams(data) });
  }

  getInstantSmsReportCsv(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetInstantSMSRptCSV', { params: this.buildQueryParams(data), responseType: 'blob' });
  }

  getInstantSmsSummaryReportCsv(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetInstantSMSSummaryRptCSV', { params: this.buildQueryParams(data), responseType: 'blob' });
  }

  getSmsSummaryReportCsv(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMSSummaryRptCSV', { params: this.buildQueryParams(data), responseType: 'blob' });
  }

  getInstantSmsReportDetail(instantSMSId: any, PageIdex: any) {
    return this.http.get(this.api + '/SMSRpt/GetInstantSMSDetailRpt?InstantSMSId='+instantSMSId+'&PageIdex='+PageIdex);
  }

  getInstantSMSDetailCsv(instantSMSId: any) {
    return this.http.get(this.api+'/SMSRpt/GetInstantSMSDetailCSV?InstantSMSId='+instantSMSId, {
      responseType: 'blob'
    });
  }

  getSmppSmsReport(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMPPSMSRpt', { params: this.buildQueryParams(data) });
  }

  getSmppSmsSummaryReport(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMPPSMSSummaryRpt', { params: this.buildQueryParams(data) });
  }

  getSmppSmsReportCsv(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMPPSMSRptCSV', { params: this.buildQueryParams(data), responseType: 'blob' });
  }

  getSmppSmsSummaryReportCsv(data: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMPPSMSSummaryRptCSV', { params: this.buildQueryParams(data), responseType: 'blob' });
  }

  getSmppSmsReportDetail(smppSMSId: any, PageIdex: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMPPSMSDetailRpt?SMPPSMSId=' + smppSMSId + '&PageIdex=' + PageIdex);
  }

  getSmppSMSDetailCsv(smppSMSId: any) {
    return this.http.get(this.api + '/SMSRpt/GetSMPPSMSDetailCSV?SMPPSMSId=' + smppSMSId, {
      responseType: 'blob'
    });
  }
}
